<p-confirmDialog [style]="{ width: '50vw' }" />

<p-treeSelect
  class="no-outline"
  #treeSelect
  containerStyleClass="w-full"
  [(ngModel)]="selectedPrompt"
  (onNodeSelect)="promptSelected.emit($event)"
  [options]="predefinedPrompts"
  placeholder="Exemples de prompt..."
  i18n-placeholder="@@prompt_selector_prompt_examples_tooltip"
  [disabled]="disabled"
  [filter]="true"
  [filterInputAutoFocus]="true"
  filterBy="key,label"
  filterPlaceholder="Rechercher par label ou ID..."
  i18n-filterPlaceholder="@@prompt_selector_prompt_filter_tooltip"
  appendTo="body"
  [showClear]="isReadOnly"
  (onClear)="promptCleared.emit()"
>
  <ng-template
    pTemplate="default"
    let-node
    [ngAs]="PromptNode"
  >
    @if (node.children) {
      <div>
        <div class="flex gap-3 align-items-center justify-content-between line">
          <b>{{ node.label }}</b>
          @if (!isReadOnly && canSeeEditButtons(node)) {
            @if (!isMyFavorites(node)) {
              <button
                class="show-on-hover-button"
                type="button"
                pTooltip="Ajouter un nouveau prompt"
                i18n-pTooltip="@@prompt_selector_add_new_prompt_tooltip"
                (click)="treeSelect.hide(); $event.stopPropagation(); openPromptEditor(node, node.data, 'add')"
                tooltipPosition="bottom"
              >
                <i class="pi pi-plus"></i>
              </button>
            }
            @if (canSeeAddNodeButtons(node)) {
              <button
                class="show-on-hover-button"
                type="button"
                pTooltip="Ajouter un nouveau noeud"
                i18n-pTooltip="@@prompt_selector_add_new_node_tooltip"
                (click)="$event.stopPropagation(); openPromptNodeEditor(node, 'add')"
                tooltipPosition="bottom"
              >
                <i class="pi pi-folder-plus"></i>
              </button>
            }
            @if (canSeeEditNodeButtons(node)) {
              <button
                class="show-on-hover-button"
                type="button"
                pTooltip="Modifier le noeud"
                i18n-pTooltip="@@prompt_selector_modify_node_tooltip"
                (click)="$event.stopPropagation(); openPromptNodeEditor(node, 'edit')"
                tooltipPosition="bottom"
              >
                <i class="pi pi-file-edit"></i>
              </button>
            }
            @if (canSeeMoveNodeButton(node)) {
              <button
                class="show-on-hover-button"
                type="button"
                pTooltip="Déplacer le noeud"
                i18n-pTooltip="@@prompt_selector_move_node_tooltip"
                (click)="$event.stopPropagation(); openMoveNodeDialog(node)"
                tooltipPosition="bottom"
              >
                <i class="pi pi-external-link"></i>
              </button>
            }
            @if (canSeeDeleteNodeButtons(node)) {
              <button
                class="show-on-hover-button"
                type="button"
                pTooltip="Supprimer le noeud"
                i18n-pTooltip="@@prompt_selector_delete_node_tooltip"
                (click)="treeSelect.hide(); $event.stopPropagation(); openNodeDeleteConfirmationDialog(node)"
                tooltipPosition="bottom"
              >
                <i class="pi pi-trash"></i>
              </button>
            }
            @if (selectedPrompt && !isMyFavorites(node)) {
              <button
                class="show-on-hover-button"
                (click)="
                  treeSelect.hide();
                  $event.stopPropagation();
                  openPromptEditor(node, selectedPrompt.data || node.data, 'copy')
                "
                pTooltip="Copier le prompt sélectionné ici"
                i18n-pTooltip="@@prompt_selector_copy_prompt_tooltip"
                tooltipPosition="bottom"
                type="button"
              >
                <i class="pi pi-copy"></i>
              </button>
            }
          }
        </div>
      </div>
    } @else {
      <div class="flex gap-3 align-items-center justify-content-between line">
        <span>{{ node.label }}</span>
        @if (!isReadOnly) {
          <div>
            @if (canSeeEditButtons(node.parent)) {
              <button
                class="show-on-hover-button mr-3"
                type="button"
                pTooltip="Éditer le prompt"
                i18n-pTooltip="@@prompt_selector_edit_prompt_tooltip"
                (click)="treeSelect.hide(); $event.stopPropagation(); openPromptEditor(node.parent, node.data, 'edit')"
                tooltipPosition="bottom"
              >
                <i class="pi pi-file-edit"></i>
              </button>
              @if (canSeeMovePromptButton(node) && !isParentMyFavorites(node)) {
                <button
                  class="show-on-hover-button mr-3"
                  type="button"
                  pTooltip="Déplacer le prompt"
                  i18n-pTooltip="@@prompt_selector_move_prompt_tooltip"
                  (click)="treeSelect.hide(); $event.stopPropagation(); openMovePromptDialog(node)"
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-external-link"></i>
                </button>
              }
              @if (canSeeDeleteButtons(node) && !isParentMyFavorites(node)) {
                <button
                  class="show-on-hover-button mr-3"
                  type="button"
                  pTooltip="Supprimer le prompt"
                  i18n-pTooltip="@@prompt_selector_delete_prompt_tooltip"
                  (click)="
                    treeSelect.hide();
                    $event.stopPropagation();
                    openDeleteConfirmationDialog(node.parent, node.data?.id)
                  "
                  tooltipPosition="bottom"
                >
                  <i class="pi pi-trash"></i>
                </button>
              }
            }
            <button
              class="show-on-hover-button mr-3"
              type="button"
              pTooltip="Copier l'ID du prompt vers le presse-papier"
              i18n-pTooltip="@@prompt_selector_copy_prompt_id_tooltip"
              (click)="$event.stopPropagation(); copyPromptId(node.data?.id)"
              tooltipPosition="bottom"
            >
              <i class="fa fa-clipboard"></i>
            </button>
            @if (!isParentMyPrompts(node)) {
              <button
                class="show-on-hover-button mr-3"
                type="button"
                [pTooltip]="favoriteButtonTooltip(node)"
                (click)="$event.stopPropagation(); toggleFavorite(node.data)"
                tooltipPosition="bottom"
              >
                @if (node.data?.isFavorite) {
                  <i class="fa fa-heart"></i>
                } @else {
                  <i class="fa fa-heart-o"></i>
                }
              </button>
            }
            @if (canCopyToMyPrompts(node)) {
              <button
                class="show-on-hover-button mr-3"
                type="button"
                pTooltip="Copier vers 'Mes prompts'"
                i18n-pTooltip="@@prompt_selector_copy_prompt_to_myprompts_tooltip"
                (click)="treeSelect.hide(); $event.stopPropagation(); copyToMyPrompts(node.data?.id)"
                tooltipPosition="bottom"
              >
                <i class="fa fa-clone"></i>
              </button>
            }
            @if (!isParentMyPrompts(node) && !this.isFloattingAssistantChat) {
              <button
                class="show-on-hover-button mr-3"
                type="button"
                pTooltip="Partager ce prompt"
                i18n-pTooltip="@@prompt_selector_share_prompt_tooltip"
                (click)="$event.stopPropagation(); sharePrompt(node.data?.id)"
                tooltipPosition="bottom"
              >
                <i class="fa fa-share-alt"></i>
              </button>
            }
          </div>
        }
      </div>
    }
  </ng-template>
</p-treeSelect>
